<template>
  <div
    class="precipitation-calculator"
  >
    <h4 class="g-title g-title--subtitle">
      Landscape Coefficient Calculator
    </h4>
    <div
      class="edit-grid"
    >
      <div class="grid__title">
        <h5 title="High: 0.7-0.9, Moderate: 0.4-0.6, Low: 0.1-0.3">
          <font-awesome-icon :icon="['fas', 'info-circle']" /> Species Factor
        </h5>
      </div>
      <div>
        <input
          v-model="speciesFactor"
          pattern= "^\d*\.?\d+$"
          type="text"
          min="0"
        >
      </div>

      <div class="grid__title">
        <h5 title="High: 1.1-1.3, Moderate: 1.0, Low: 0.5-0.9">
          <font-awesome-icon :icon="['fas', 'info-circle']" /> Density
        </h5>
      </div>
      <div>
        <input
          v-model="density"
          pattern= "^\d*\.?\d+$"
          type="text"
          min="0"
        >
      </div>
      <h5 title="High: 1.1-1.4, Moderate: 1.0, Low: 0.5-0.9">
        <font-awesome-icon :icon="['fas', 'info-circle']" /> Micro Climate
      </h5>
      <div>
        <input
          v-model="microClimate"
          pattern= "^\d*\.?\d+$"
          type="text"
          min="0"
        >
      </div>

      <div class="grid__title">
        <h5>Landscape Coefficient</h5>
      </div>
      <div>
        <input
          :value="computedLandscapeCoefficient"
          pattern= "^\d*\.?\d+$"
          disabled
          type="text"
          min="0"
        >
      </div>
      <button
        class="g-btn g-btn--blue g-btn--rounded"
        :disabled="computedLandscapeCoefficient === 0"
        @click.stop="transferValue"
      >
        Transfer Value
      </button>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
  name: 'LandscapeCoefficientCalculator',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return {
      speciesFactor: 0,
      density: 0,
      microClimate: 0
    }
  },
  computed: {
    computedLandscapeCoefficient() {
      if(this.speciesFactor && this.density && this.microClimate)
        return this.speciesFactor * this.density * this.microClimate
      return 0
    }
  },
  methods: {
    transferValue() {
      console.log('click')
      this.$emit('transfer-landscape', this.computedLandscapeCoefficient)
    }
  }
}
</script>

<style lang="scss">
  .precipitation-calculator {
    h4 {
      margin-top: 10px;
    }

    h5 {
      cursor: help;
    }

    .copy {
      text-align: right;
      margin-right: 20px;

      button[disabled] {
        background-color: $color-grey;
      }
    }
  }
</style>